import React from "react";

import filterModalStyles from "../../filterModal.module.scss";
import FilterCheckBox from "@/src/components/FilterCheckBox";
import { useCommonContext } from "@/src/provider/Common/context";
import { useFilterConditionContext } from "@/src/provider";
import { useTranslation } from "@/src/i18n/client";
const GenderContent: React.FC = () => {
    const [genderData, genderSelect] = useFilterConditionContext((state) => [
        state.genderData,
        state.genderSelect,
    ]);
    const { t } = useTranslation("specialSub");
    const { siteId } = useCommonContext();
    const onChange = (id: number) => {
        genderSelect(id);
    };
    const currentGender =
        siteId == 2 ? genderData.filter((val) => val.id !== 3) : genderData;

    return (
        <div
            className={filterModalStyles["filter-content-item"]}
            style={{ display: "block" }}
        >
            {currentGender.map((val, key) => (
                <div
                    className={filterModalStyles["filter-content-Radio"]}
                    key={val.id}
                >
                    <FilterCheckBox
                        title={`${t(val.title)}`}
                        id={val.id}
                        checked={val.active}
                        onChange={() => onChange(val.id)}
                    />
                </div>
            ))}
        </div>
    );
};

export default GenderContent;
